import styled from '@emotion/styled';

export const DropdownWrap = styled.div<{ isOpen: boolean }>`
  left: 16px;
  overflow: ${props => (props.isOpen ? 'visible' : 'hidden')};
  position: absolute;
  top: 48px;
  z-index: 60;
  .innerWrap {
    background: #ffffff;
    border-radius: 5px;
    border: ${props => props.isOpen && '1px solid #e5e5ea'};
    height: ${props => (props.isOpen ? 'auto' : '0px')};
    overflow: ${props => (props.isOpen ? 'auto' : 'hidden')};
    padding: ${props => props.isOpen && '8px'};
    width: 320px;
    max-height: 450px;
  }
  .search-section {
    align-items: center;
    display: flex;
    justify-content: space-between;
    .search-wrap {
      align-items: center;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #e5e5ea;
      display: flex;
      padding: 0 16px;
      width: calc(100% - 48px);
      input {
        border: none;
        height: 38px;
        outline: none;
        padding: 0 8px;
        width: 100%;
      }
    }
    .addButton {
      align-items: center;
      background: #f7f7f9;
      border-radius: 5px;
      color: #8e8e93;
      cursor: pointer;
      display: flex;
      font-size: 24px;
      height: 32px;
      justify-content: center;
      width: 32px;
      border-radius: 50%;
      position: absolute;
      right: -12px;
      top: -12px;
      border: 1px solid #e5e5ea;
      transition: all 0.1s;
      :hover {
        background: #ffffff;
        border-color: #333;
      }
      svg {
        max-width: 14px;
      }
    }
  }
`;

export const MenuItem = styled.div`
  .menuHeader {
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    display: flex;
    height: 40px;
    justify-content: space-between;
    padding: 10px 16px;
    font-weight: 700;
    :hover {
      background: #f7f7f9;
    }
  }
`;
